/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { createNamespacedWetagHooksForUser, createNamespacedWetagHooksForOrg } from '@frontend/wetags';
import type { SalesDemoTags } from './tags';

const SALES_DEMO_NAMESPACE = 'sales-demo';

export const SalesDemoUser = createNamespacedWetagHooksForUser<SalesDemoTags>(SALES_DEMO_NAMESPACE);
export const SalesDemoOrg = createNamespacedWetagHooksForOrg<SalesDemoTags>(SALES_DEMO_NAMESPACE);
